/* eslint-disable react/require-default-props */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import FireClass from '../../lib/fire';

import styles from '../../styles/partials/fire.module.css';

const propTypes = {
    config: PropTypes.shape({
        speed: PropTypes.number,
        intensity: PropTypes.number,
    }),
    items: PropTypes.arrayOf(PropTypes.shape({})),
    count: PropTypes.number,
    user: PropTypes.string,
    onReady: PropTypes.func,
    className: PropTypes.string,
};

function Fire({
    config = null,
    items = [],
    count = null,
    user = null,
    onReady = null,
    className = null,
}) {
    const [, setSize] = useState(
        typeof window !== 'undefined'
            ? { width: window.innerWidth, height: window.innerHeight }
            : { width: 0, height: 0 },
    );
    // const { width, height } = size || {};

    const appRef = useRef(null);
    const fireRef = useRef(null);
    const fireContainerRef = useRef(null);
    const [ready, setReady] = useState(false);

    // Init fire
    useEffect(() => {
        if (fireRef.current === null) {
            fireRef.current = new FireClass(fireContainerRef.current, config, items);
            fireRef.current.init().then((app) => {
                appRef.current = app;
                setReady(true);
                if (onReady !== null) {
                    onReady(fireRef.current);
                }
            });
        }
        return () => {
            if (
                fireRef.current !== null &&
                appRef.current !== null &&
                fireContainerRef.current !== null
            ) {
                fireContainerRef.current.removeChild(appRef.current.canvas);
                appRef.current.destroy();
                appRef.current = null;
                fireRef.current = null;
                setReady(false);
            }
        };
    }, [setReady, onReady]);

    // Update fire params
    useEffect(() => {
        if (fireRef.current !== null && appRef.current !== null) {
            fireRef.current.update(config, items, user);
        }
    }, [count, ready, user]);

    const onResize = useCallback((e) => {
        const { innetWidth: newWidth = null, innerHeight: newheight = null } = e.target;
        setSize({ width: newWidth, height: newheight });
        if (appRef.current !== null) {
            // Wipeout
            appRef.current.renderer.resize(newWidth, newheight);
            fireContainerRef.current.removeChild(appRef.current.canvas);
            appRef.current.destroy();
            appRef.current = null;
            fireRef.current = null;
            setReady(false);

            // Recreate
            fireRef.current = new FireClass(fireContainerRef.current, config, items);
            fireRef.current.init().then((app) => {
                appRef.current = app;
                setReady(true);
                if (onReady !== null) {
                    onReady(fireRef.current);
                }
            });
        }
    }, []);

    useEffect(() => {
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    return (
        <div
            ref={fireContainerRef}
            className={classNames([styles.container, { [className]: className !== null }])}
        />
    );
}

Fire.propTypes = propTypes;

export default Fire;
